var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"icon"}),_c('div',{staticClass:"text"},[_vm._v("很抱歉，页面丢失了，请重新找回……")]),_c('ykc-button',{staticClass:"btn",on:{"click":_vm.handleBack}},[_vm._v("返回首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }